<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    color?: string;
  }>(),
  {
    width: "24px",
    color: getCSSVar("--xg-orange")
  }
);
</script>

<template>
  <svg
    viewBox="0 0 48 48"
    :width="props.width"
    :height="props.height ?? props.width"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="transform-origin: center"
  >
    <path
      d="M24 46.5C36.4264 46.5 46.5 36.4264 46.5 24C46.5 11.5736 36.4264 1.5 24 1.5C11.5736 1.5 1.5 11.5736 1.5 24C1.5 36.4264 11.5736 46.5 24 46.5Z"
      :fill="props.color"
    />
    <rect
      x="22.5"
      y="10.5"
      width="3"
      height="16.5"
      rx="1.5"
      fill="white"
    />
    <rect
      x="37.5"
      y="24"
      width="3"
      height="15"
      rx="1.5"
      transform="rotate(90 37.5 24)"
      fill="white"
    />
  </svg>
</template>
